// Lead Basic section keywords
export const leadBasicKeywords = [
  "lead",
  "basic",
  "active",
  "inactive",
  "active / inactive",
  "info",
  "information",
  "priority",
  "importance",
  "urgency",
  "high",
  "medium",
  "low",
  "none",
  "role",
  "roles",
  "user",
  "users",
  "agent",
  "employee",
  "team member",
  "assignment",
  "assignments",
  "assigned",
  "unassigned",
  "reassigned",
  "status",
  "branch",
  "branches",
  "office",
  "location",
].join(" ");

// Source & Campaign section keywords (lead source, source type, meta page,
// meta ad account, campaign, ad set, ad).
export const sourceCampaignKeywords = [
  "source",
  "sources",
  "source type",
  "type",
  "types",
  "lead source",
  "campaign",
  "campaigns",
  "ads",
  "ad account",
  "meta",
  "facebook",
  "fb",
  "instagram",
  "ig",
  "page",
  "pages",
  "meta page",
  "meta pages",
  "ad accounts",
  "ad set",
  "ad sets",
  "adset",
  "adsets",
  "ad",
  "creative",
  "creatives",
  "video",
  "videos",
  "whatsapp",
  "google",
  "website",
  "referral",
  "telecmi",
  "custom",
].join(" ");

// Funnel Info section keywords
export const funnelInfoKeywords = [
  "funnel",
  "pipeline",
  "workflow",
  "stage",
  "stages",
  "step",
  "steps",
  "status",
  "statuses",
  "state",
  "substatus",
  "sub-status",
  "sub status",
  "sub statuses",
  "progress",
  "conversion",
  "flow",
].join(" ");

// Tracks section keywords
export const tracksKeywords = [
  "track",
  "tracks",
  "tracking",
  "routing",
  "route",
  "track status",
  "active",
  "completed",
  "paused",
  "cancelled",
  "has active track",
  "ongoing",
  "engineering",
  "business",
  "medicine",
  "arts",
  "law",
].join(" ");

// Activity Filters section keywords
export const activityKeywords = [
  "activity",
  "activities",
  "logs",
  "history",
  "timeline",
  "paused",
  "paused activity",
  "paused activity for",
  "inactive",
  "inactive for",
  "days",
  "idle",
  "dormant",
  "no activity",
  "last contacted",
  "contacted between",
  "contact date",
  "reach out",
  "contacted by",
  "team member",
  "agent",
  "who contacted",
  "next followup",
  "follow up",
  "follow-up",
  "followup date",
  "reminder",
  "scheduled",
  "last activity",
  "last activity date",
  "recent activity",
  "latest",
  // Team Activity filter (mirrors ACTIVITY_FILTER_TYPES + its own controls) —
  // these fields shipped after the original list and were unfindable by search.
  "team activity",
  "activity type",
  "type",
  "activity by",
  "performed by",
  "done by",
  "anyone",
  "assignation",
  "assigned",
  "was called",
  "got a note",
  "note",
  "notes",
  "chat",
  "team chat",
  "discussed",
  "followup created",
  "follow-up scheduled",
  "followup completed",
  "follow-up completed",
  "whatsapp",
  "email",
  "stage move",
  "stage was moved",
  "stage change",
].join(" ");

// Call Filters section keywords
export const callKeywords = [
  "call",
  "calls",
  "call log",
  "call logs",
  "phone",
  "phone call",
  "dial",
  "dialed",
  "dialled",
  "telephony",
  "telecmi",
  "pbx",
  "mobile app",
  "call activity",
  "has calls",
  "never called",
  "not called",
  "uncalled",
  "call direction",
  "incoming",
  "inbound",
  "outgoing",
  "outbound",
  "call outcome",
  "call type",
  "call status",
  "connected",
  "answered",
  "missed",
  "missed call",
  "no answer",
  "unanswered",
  "rejected",
  "blocked",
  "busy",
  "called by",
  "caller",
  "called between",
  "call date",
  "number of calls",
  "call count",
  "attempts",
  "talk time",
  "duration",
  "call duration",
  "recording",
  "recordings",
  "call recording",
  "audio",
].join(" ");

// Academic Background section keywords
export const academicKeywords = [
  "academic",
  "education",
  "study",
  "university",
  "college",
  "school",
  "background",
  "highest qualification",
  "qualification",
  "degree",
  "high school",
  "diploma",
  "bachelor",
  "master",
  "phd",
  "doctorate",
  "10th",
  "tenth",
  "ssc",
  "secondary",
  "12th",
  "twelfth",
  "hsc",
  "higher secondary",
  "intermediate",
  "ug",
  "undergraduate",
  "bachelors",
  "graduation",
  "pg",
  "postgraduate",
  "masters",
  "post graduation",
  "score",
  "percentage",
  "cgpa",
  "gpa",
  "marks",
  "grade",
  "ielts",
  "toefl",
  "pte",
  "gre",
  "gmat",
  "test score",
  "english proficiency",
].join(" ");

// Study Preferences section keywords
export const studyPreferencesKeywords = [
  "study",
  "preference",
  "preferences",
  "preferred",
  "intake",
  "intake month",
  "intake year",
  "admission",
  "enrollment",
  "session",
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
  "country",
  "preferred country",
  "destination",
  "abroad",
  "usa",
  "uk",
  "canada",
  "australia",
  "germany",
  "france",
  "united states",
  "united kingdom",
  "course",
  "preferred course",
  "program",
  "programme",
  "major",
  "field",
  "computer science",
  "engineering",
  "business",
  "medicine",
  "law",
  "arts",
].join(" ");

// Deal Info section keywords (the section is labelled "Deal Info" since
// 2026-09-04; the old "choice" wording is kept here so existing muscle memory
// still finds it).
export const choiceInfoKeywords = [
  "deal",
  "deals",
  "has deals",
  "number of deals",
  "deals applied in",
  "deals last updated",
  "choice",
  "choices",
  "selection",
  "selections",
  "application",
  "has choices",
  "at least one choice",
  "number of choices",
  "count",
  "how many",
  "choices applied in",
  "applied",
  "application date",
  "date range",
  "last week",
  "last month",
  "last year",
  "custom range",
  "choices last updated",
  "last updated",
  "updated date",
  "modified",
  "offer",
  "offer received",
  "accepted",
  "rejected",
  "rejection",
  "declined",
].join(" ");

// Payment section keywords
export const paymentKeywords = [
  "payment",
  "payments",
  "paid",
  "unpaid",
  "no paid",
  "not paid",
  "fully paid",
  "partial",
  "partially paid",
  "advance",
  "advance paid",
  "pending",
  "pending payment",
  "owed",
  "owes",
  "outstanding",
  "balance",
  "due",
  "amount due",
  "deal",
  "deal value",
  "total deal value",
  "quote",
  "quoted",
  "amount",
  "money",
  "fees",
  "fee",
  "price",
  "revenue",
  "net amount",
  "discount",
  "min amount",
  "max amount",
  "range",
  "financials",
  "billing",
  "invoice",
].join(" ");

// FollowUp Filters section keywords (active follow-ups in a date range)
export const followupKeywords = [
  "follow up",
  "followup",
  "follow-up",
  "followups",
  "active followup",
  "pending followup",
  "scheduled",
  "reminder",
  "reminders",
  "due",
  "overdue",
  "today",
  "this week",
  "this month",
  "upcoming",
  "next followup",
  "followup date",
  "followup range",
].join(" ");

// Date Filters section keywords
export const dateFiltersKeywords = [
  "date",
  "dates",
  "custom",
  "custom range",
  "date range",
  "time",
  "timeframe",
  "period",
  "range",
  "created",
  "created date",
  "creation date",
  "when created",
  "added on",
  "registered",
  "updated",
  "updated date",
  "modification date",
  "when updated",
  "last modified",
  "changed",
].join(" ");
